export default "__VITE_ASSET__CFtObCle__"